import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=6abaf3d6&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=ts"
export * from "./IconComponent.vue?vue&type=script&lang=ts"
import style0 from "./IconComponent.vue?vue&type=style&index=0&id=6abaf3d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abaf3d6",
  null
  
)

export default component.exports